import { useContext } from "react"
import { PageContext } from "../../../contexts"
import AdminMenu from "./admin-menu"
import AuditorMenu from "./auditor-menu"
import ImplementerMenu from "./implementer-role-menus/implementer-menu"
import MultiRoleMenu from "./multi-role-menu"
import ImplementerEvaluatorMenu from "./implementer-role-menus/implementer-evaluator-menu"
import { ImplementerFinancialMonitorMenu } from "./implementer-role-menus/implementer-financial-monitor-menu"
import { ImplementerTechnicalMonitorMenu } from "./implementer-role-menus/implementer-technical-monitor-menu"
import { ImplementerAttendanceMonitorMenu } from "./implementer-role-menus/implementer-attendance-monitor-menu"
import { PaymentMenu } from "./payment-menu"
import ImplementerCoordinatorMenu from "./implementer-role-menus/implementer-coordinator-menu"
import ImplementerSystematizerMenu from "./implementer-role-menus/implementer-systematizer-menu"

export function MainMenu() {
  const { type, step, submenu, userPermissions, userRoles } = useContext(PageContext)

  if (!userPermissions) {
    console.error("MISSING USER PERMISSIONS")
  }

  const menus = {
    "ADMIN": <AdminMenu step={step} submenu={submenu} />,
    "ADMIN_PAYMENTS": <AdminMenu step={step} submenu={submenu} />,
    "ADMIN_ASSISTANT": <AdminMenu step={step} submenu={submenu} />,
    "ADMIN_TECHNICAL_AND_FINANCIAL":<AdminMenu step={step} submenu={submenu} />,
    "ADMIN_BASIC": <AdminMenu step={step} submenu={submenu} />,
    "ADMIN_EVALUATOR":<AdminMenu step={step} submenu={submenu} />,
    "ADMIN_AUDITOR": <AuditorMenu step={step} submenu={submenu} />,
    "IMPLEMENTER": <ImplementerMenu step={step} submenu={submenu} />,
    "IMPLEMENTER_TECHNICAL_MONITOR": <ImplementerTechnicalMonitorMenu step={step} submenu={submenu} />,
    "IMPLEMENTER_ATTENDANCE_MONITOR": <ImplementerAttendanceMonitorMenu step={step} submenu={submenu} />,
    "IMPLEMENTER_FINANCIAL_MONITOR": <ImplementerFinancialMonitorMenu step={step} submenu={submenu} />,
    "IMPLEMENTER_EVALUATOR": <ImplementerEvaluatorMenu step={step} submenu={submenu} />,
    "IMPLEMENTER_COORDINATOR": <ImplementerCoordinatorMenu step={step} submenu={submenu} />,
    "IMPLEMENTER_SYSTEMATIZER" : <ImplementerSystematizerMenu step={step} submenu={submenu} />
  }

  // we will use the last role in case the user has more than one
  const role = Array.from(userRoles).pop()

  return menus[role] || (
    <MultiRoleMenu // Will handle "LOCAL_COUNCIL", "DIRECTIVE_COUNCIL", "TECHNICAL_COMMITTEE"
      step={step}
      roles={type} // this component support multi-roles in a string separated by commas "DIRECTIVE_COUNCIL TECHNICAL_COMMITTEE"
      submenu={submenu} />
  )
}
